import { LanguageModel } from './language.model';

export class TerritoryModel {
  public id: number;
  public label: string;
  public codeISO: string;
  public isGroup: boolean;
  public groupTerritoryList: TerritoryModel[];
  public languages: LanguageModel[];

  constructor() {
    this.id = null;
    this.label = '';
    this.codeISO = '';
    this.isGroup = null;
  }

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
